import apiPaths from '../api-paths';

const URL = `${ apiPaths.STAFF }/accident-insurances`;
const MODEL_KEY = 'accidentinsurance';

export default {
  index() {
    return axios.get(URL);
  },
  show({ id }) {
    return axios.get(`${ URL }/${ id }`);
  },
  store({ data }) {
    return axios.post(URL, { [MODEL_KEY]: data });
  },
  update({ data }) {
    return axios.put(`${ URL }/${ data.id }`, { [MODEL_KEY]: data });
  },
  destroy({ id }) {
    return axios.delete(`${ URL }/${ id }`);
  },
  // `id` (edit only): the backend keeps the record's stored end date while its start is unchanged.
  period({ from, id = null }) {
    return axios.get(`${ URL }/period`, { params: id ? { from, id } : { from } });
  },
  nextPeriod({ id }) {
    return axios.get(`${ URL }/${ id }/next-period`);
  },
  auditLog(query = '') {
    return axios.get(`${ URL }/audit-log${ query }`);
  },
};
